/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-20 20:27:56
 * @LastEditTime: 2022-01-20 23:26:26
 * @LastEditors: zhao - 🍉
 * @Description: Table表单
 * @FilePath: /zhzj-admin/src/components/GroupForm/index.jsx
 */
import React from 'react'
import { Icon, Input, InputNumber, Select, Table } from 'antd'
const GroupForm = (props) => {
    const handleAdd =() => {
        const value = props.value.concat({})
        props.onChange && props.onChange(value)
    }
    // 删除行
    const handleDelete = (index) => {
        const value = props.value.filter((e,i) => index !== i)
        props.onChange && props.onChange(value)
    }

    // 单个行修改
    const handleChange = (value, index, type) => {
        const values = props.value.map((row, rowIndex) => {
            if (rowIndex === index) {
                return {...row, [type]: value}
            }
            return row
        })
        props.onChange && props.onChange(values)
    }

    const iconStyle = {
        fontSize: 22,
        color: '#999',
        cursor: 'pointer'
    }
    
 
    
    const parseColumns = (columns) => {
        const result = columns.map(e => {
            if (!e.render) {
                e.render = (text, record, index) => {
                    if (e.type === 'input') {
                        return <Input size="small" value={text} disabled={!!e.disabled} placeholder={e.placeholder || '请输入'} onChange={(ev) => handleChange(ev.target.value, index, e.dataIndex )}  />
                    } 
                    if (e.type === 'number') {
                        return <InputNumber size="small" value={text} disabled={!!e.disabled} placeholder={e.placeholder || '请输入'} onChange={(ev) => handleChange(ev, index, e.dataIndex )}  />
                    } 
                    if (e.type === 'select') {
                        return (
                            <Select 
                                style={{width: '100%'}} 
                                size="small" 
                                value={text} 
                                onChange={(ev) => handleChange(ev, index, e.dataIndex )}
                                disabled={!!e.disabled}
                                placeholder={e.placeholder || '请选择'}
                            >
                                {e.options.map(option => <Select.Option key={option.value} value={option.value}>{option.title}</Select.Option> )}
                            </Select>
                        )
                    }
                    return null
                }
            }
            return e
        })
        if (props.hideAction !== true) {
            result.push({ title: '删除', dataIndex: 'action', width: 46, render:(text, record, index) => {
                return <Icon type="minus-circle" style={iconStyle}  onClick={() => handleDelete(index)} />
            } })
        }
        return result
    }

    return (
        <div>
            {props.hideAction !== true && (
                <div style={{ textAlign: 'right', paddingRight:14 }}>
                    <Icon type="plus-circle" style={iconStyle} onClick={handleAdd} />
                </div>
            )}
            <Table columns={parseColumns(props.columns)} bordered pagination={false} dataSource={props.value} />
        </div>
    )
}

export default GroupForm


// WEBPACK FOOTER //
// ./src/components/GroupForm/index.jsx